export class BroadcastMessages {
  broadcastMessageId: any;
  businessType: any;
  messageStartDate: any;
  messageEndDate: any;
  messageText: any;
}
